import { store } from '@/store';

const isCurrentUser = (vue, push) => (vue.$store.state.users && vue.$store.state.users.current && vue.$store.state.users.current.id && push.user && push.user.id && parseInt(push.user.id) === parseInt(vue.$store.state.users.current.id)) 

export default {
  //Добавление заявки
  deals_postdeals(data, vue) {
    if (!data || !data.data) return;
    if (vue.$route.name != 'DealNew' && vue.$route.name != 'DealsNew') return;

    const deal = Object.assign({}, data.data);
    if (!deal || !deal.id) return;

    let page = parseInt(store.state.deals.currentDealsPage),
        loadOnScroll = (vue.$route.query) ? vue.$route.query.load_on_scroll : false,
        hasFilter    = (vue.$route.query && (vue.$route.query.custom_filter || vue.$route.query.search)) ? true : false;
    
    //Если в списке заявок указан фильтр, то не добавляем новые заявки в список
    //(это мешает работе т.к. фильтруют только конкретные заявки)
    if (hasFilter || store.state.deals.hasDealsFilter) return;

    if (store.state.deals.deals && (page === 1 || loadOnScroll)) {
      deal.routerLink = { name: 'DealNew', params: { id: deal.id } };
      if (deal.first_freight && deal.first_freight.id) deal.first_freight_id = deal.first_freight.id;
      store.commit('deals/unshiftDeal', deal);
    }
  },

  //Изменение заявки
  deals_putdeals(data, vue) {
    if (!data || !data.data) return;
    if (vue.$route.name != 'DealNew' && vue.$route.name != 'DealsNew') return;

    const deal = Object.assign({}, data.data);
    if (!deal || !deal.id) return;

    //Обновление в списке
    if (store.state.deals.deals && Array.isArray(store.state.deals.deals)) {
      deal.routerLink = { name: 'DealNew', params: { id: deal.id } };
      const index = store.state.deals.deals.findIndex(item => (item && parseInt(item.id) === parseInt(deal.id)))
      if (deal.first_freight && deal.first_freight.id) deal.first_freight_id = deal.first_freight.id;
      if (index >= 0) store.commit('setStateObject', ['deals.deals.' + index, deal]);
    }

    if (isCurrentUser(vue, data)) return;
    //Обновление в карточке
    if (vue && vue.$root && store.state.deals && store.state.deals.deal && store.state.deals.deal.id == deal.id) vue.$root.$emit('update-deal-form', deal);
  },

  //Подпись заявки
  deals_signaturedeals(data, vue) {
    if (!data || !data.data || isCurrentUser(vue, data) || vue.$route.name != 'DealNew') return;
    data = Object.assign({}, data.data);
    vue.$root.$emit('update-deal-signature', {id: data.id, type: data.type, signature: data.signature, date: data.date});
  },

  //Добавление трекинга
  deals_posttracking(data, vue) {
    if (!data || !data.data) return;
    if (vue.$route.name != 'DealNew' && vue.$route.name != 'DealsNew') return;
    
    const tracking = Object.assign({}, data.data);
    if (!tracking || !tracking.id) return;

    //обновляем трекинг в карточке заявки
    if (vue.$route.name == 'DealNew' && !isCurrentUser(vue, data)) vue.$root.$emit('update-freight-tracking', data);

    if (store.state.deals.deals && Array.isArray(store.state.deals.deals)) {
      const index = store.state.deals.deals.findIndex((item) => (item.first_freight && parseInt(item.first_freight.id) === parseInt(tracking.freight_id)));
      if (index >= 0) {
        const deal = Object.assign({}, store.state.deals.deals[index]);
        deal.first_freight.currenttracking = Object.assign({}, tracking);
        if (tracking.status_id) deal.first_freight.status_id = tracking.status_id;
        if (tracking.status)    deal.first_freight.status    = Object.assign({}, tracking.status);
        store.commit('setStateObject', ['deals.deals.' + index, deal]);
      }
    }
  },

  //Обновление трекинга
  deals_puttracking(data, vue) {
    if (!data || !data.data) return;
    if (vue.$route.name != 'DealNew' && vue.$route.name != 'DealsNew') return;

    const tracking = Object.assign({}, data.data);
    if (!tracking || !tracking.id) return;

    //обновляем трекинг в карточке заявки
    if (vue.$route.name == 'DealNew' && !isCurrentUser(vue, data)) vue.$root.$emit('update-freight-tracking', data);

    if (store.state.deals.deals && Array.isArray(store.state.deals.deals)) {
      const index = store.state.deals.deals.findIndex((item) => (item.first_freight && parseInt(item.first_freight.id) === parseInt(tracking.freight_id)));
      if (index >= 0) {
        const deal = Object.assign({}, store.state.deals.deals[index]);
        deal.first_freight.currenttracking = Object.assign({}, tracking);
        if (tracking.status_id) deal.first_freight.status_id = tracking.status_id;
        if (tracking.status)    deal.first_freight.status    = Object.assign({}, tracking.status);
        store.commit('setStateObject', ['deals.deals.' + index, deal]);
      }
    }
  },

  //удаление трекинга
  deals_deletetracking(data, vue) {
    if (!data || !data.data || vue.$route.name != 'DealNew') return;
    vue.$root.$emit('update-freight-tracking', data);
  },

  //Добавление МЛ
  deals_postdealsroutelist(data, vue) {
    if (!data || !data.data) return;
    if (vue.$route.name != 'DealNew' && vue.$route.name != 'DealsNew' && vue.$route.name != 'Itineraries' && vue.$route.name != 'Itinerary' && vue.$route.name != 'ItineraryFreights') return;

    let Filter = (vue.$route.query && vue.$route.query.custom_filter) ? Object.assign({}, JSON.parse(vue.$route.query.custom_filter)) : {},
        hasFilter = Object.values(Filter).find(item => Array.isArray(item) && item.length || !Array.isArray(item) && item);

    //Если в списке указан фильтр, то не добавляем новые МЛ в список
    //(это мешает работе т.к. фильтруют только конкретные МЛ)
    if (hasFilter) return;

    const RouteList = Object.assign({}, data.data);
    if (!RouteList || !RouteList.id) return;
    vue.$root.$emit('update-itinerary-form', RouteList.id);

    if (RouteList && RouteList.freights) RouteList.freights_ids = RouteList.freights.map(freight => parseInt(freight.id));
    if (RouteList.id && store.state.deals.route_lists && parseInt(store.state.deals.currentItinerariesPage) === 1) store.commit('deals/unshiftItinerary', RouteList);
  },

  //Изменение МЛ
  deals_putdealsroutelist(data, vue) {
    if (!data || !data.data) return;
    //Если запрос обновления делал текущий пользователь, то форму обновлять не надо
    if (vue.$store.state.users.current && data.user.id && parseInt(data.user.id) === parseInt(vue.$store.state.users.current.id)) return;
    if (vue.$route.name != 'DealNew' && vue.$route.name != 'DealsNew' && vue.$route.name != 'Itineraries' && vue.$route.name != 'Itinerary' && vue.$route.name != 'ItineraryFreights') return;
    if (vue.$route.name == 'Itinerary') vue.$root.$emit('update-itinerary-form', data.data.id);
    
    const RouteList = Object.assign({}, data.data);
    if (!RouteList || !RouteList.id) return;

    RouteList.freights_ids = [];
    if (RouteList && RouteList.freights) RouteList.freights_ids = RouteList.freights.map(freight => parseInt(freight.id));
    if (store.state.deals.route_lists && Array.isArray(store.state.deals.route_lists)) {
      const index = store.state.deals.route_lists.findIndex(item => (parseInt(RouteList.id) == parseInt(item.id)));
      if (index >= 0) store.commit('setStateObject', ['deals.route_lists.' + index, RouteList]);
    }
  },

  //Удаление МЛ
  deals_deletedealsroutelist(data, vue) {
    if (!data || !data.data) return;
    if (vue.$route.name != 'DealNew' && vue.$route.name != 'DealsNew' && vue.$route.name != 'Itineraries' && vue.$route.name != 'Itinerary' && vue.$route.name != 'ItineraryFreights') return;

    const RouteList = Object.assign({}, data.data);
    if (!RouteList || !RouteList.id) return;

    if (store.state.deals.route_lists && Array.isArray(store.state.deals.route_lists)) {
      const index = store.state.deals.route_lists.map(item => (parseInt(item.id) === parseInt(RouteList.id)));
      if (index >= 0) store.commit('deleteStateObject', ['deals.route_lists.' + index]);
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/deals/pusher.js